
export default function initLogin() {
    
    new Vue({
        el: "#login_form",
        data: {
            login_form: {
                email: '',
                password: '',
                remember: '',
            },
            reset_form: {
                email: '',
            },
            forgot_password: false,
            form_errors: '',
            form_success: ''
        },
        mounted() {
            
        },
        methods: {
            submitLogin() {
                this.$validator.validateAll('login').then((result) => {
                    if (result) { 
                        axios.post('/login', this.login_form, {
                            headers: {
                                'Content-Type': 'application/json'
                            },
                        })
                        .then( response => {
                            location.reload();
                        })  
                        .catch( e => { 
                            if(e.response.data.errors) {
                                this.form_errors = e.response.data.errors
                            }
                        });
                    }
                });
            },
            submitReset() {
                this.$validator.validateAll('reset').then((result) => {
                    if (result) { 
                        axios.post('/reset-password', this.reset_form, {
                            headers: {
                                'Content-Type': 'application/json'
                            },
                        })
                        .then( response => {
                            this.form_success = response.data.message;
                            this.form_errors = "";
                        })  
                        .catch( e => { 
                            if(e.response.data.errors) {
                                this.form_errors = e.response.data.errors.email[0]
                            }
                        });
                    }
                });
            },
            logout() { 
                axios.get('/logout')
                .then( response => {
                    location.reload();
                })  
                .catch( e => { 
                    if(e.response.data.errors) {
                        this.form_errors = e.response.data.errors
                    }
                });
            },
        }
    });

}